'use strict';

var dateFnsTz = require('date-fns-tz');
var constants = require('../constants.cjs');

const formatISOInTimeZone = ({ timeZone, timestamp }) => {
  return dateFnsTz.formatInTimeZone(timestamp, timeZone, constants.ISO_FULL_FORMAT);
};

module.exports = formatISOInTimeZone;
//# sourceMappingURL=formatISOInTimeZone.cjs.map
